<div id="dashboard-mobile" class="pb-1" *ngIf="isTablet$ | async">
    <div class="menu-container mt-3 mb-1 ps-4">
        <app-burger-menu (expandedState)="displayMenu($event)" menuTitle="Dashboard Menu">
            <div class="menu-items px-4 py-1" @fadeSlideInOut *ngIf="isMenuCollapsed">
                <div *ngIf="!this.userService.hasStudentExperience()" class="item">
                    <app-link
                        [attr.data-gtmlabel]="'Dashboard'"
                        appRouterLink="/tools/dashboard/"
                        class="{{ gtmPrefix + 'dashboard' }}"
                        [ngClass]="{
                            'accessed-route': checkIfActiveRoute('/dashboard/')
                        }"
                    >
                        <app-icon [type]="'dashboard2'" class="ms-0"></app-icon>
                        Dashboard
                    </app-link>
                </div>
                <div *ngIf="!this.userService.hasStudentExperience()" class="item">
                    <app-link
                        [attr.data-gtmlabel]="'Tools'"
                        appRouterLink="/tools/lessonbuilder/"
                        class="{{ gtmPrefix + 'tools' }}"
                        [ngClass]="{
                            'accessed-route': checkIfActiveRoute('/tools/lessonbuilder/')
                        }"
                    >
                        <app-icon [type]="'lesson-builder'" class="ms-0"></app-icon>
                        Lesson Builder
                    </app-link>
                </div>

                <div
                    [ngClass]="{
                        'student-item': this.userService.hasStudentExperience(),
                        'accessed-route': checkIfActiveRoute(
                            !this.userService.hasStudentExperience()
                                ? '/tools/assignments/'
                                : '/student/assignments/'
                        )
                    }"
                    class="item"
                >
                    <app-link
                        [appRouterLink]="
                            !this.userService.hasStudentExperience()
                                ? '/tools/assignments/'
                                : '/student/assignments/'
                        "
                        [attr.data-gtmlabel]="'Assignments'"
                        [badgeCount]="assignmentsNotStarted"
                        class="gtm-header-dropdown-assignments"
                    >
                        <app-icon [type]="'AssignClass'" class="ms-0" scale="1.3"></app-icon>
                        Assignments
                    </app-link>
                </div>

                <div
                    [ngClass]="{ 'student-item': this.userService.hasStudentExperience() }"
                    class="item"
                >
                    <app-link
                        [appRouterLink]="
                            !this.userService.hasStudentExperience()
                                ? '/tools/classes'
                                : '/student/classes/'
                        "
                        [attr.data-gtmlabel]="'Classes'"
                        class="gtm-header-dropdown-rosters"
                        [ngClass]="{
                            'accessed-route': checkIfActiveRoute(
                                !this.userService.hasStudentExperience()
                                    ? '/tools/classes/'
                                    : '/student/classes/'
                            )
                        }"
                    >
                        <app-icon [type]="'classes'" class="ms-0"></app-icon>
                        Classes
                    </app-link>
                </div>
                <div
                    [ngClass]="{ 'student-item': this.userService.hasStudentExperience() }"
                    class="item"
                >
                    <app-link
                        [attr.data-gtmlabel]="'Favorites'"
                        appRouterLink="/tools/favorites/"
                        class="gtm-header-dropdown-favorites"
                        [ngClass]="{ 'accessed-route': checkIfActiveRoute('/tools/favorites/') }"
                    >
                        <app-icon [type]="'FavoriteFilled'" class="ms-0"></app-icon>
                        Favorites
                    </app-link>
                </div>

                <div
                    [ngClass]="{ 'student-item': this.userService.hasStudentExperience() }"
                    class="item"
                >
                    <app-link
                        [attr.data-gtmlabel]="'Folders'"
                        appRouterLink="/tools/folders/"
                        class="gtm-header-dropdown-folders"
                        [ngClass]="{ 'accessed-route': checkIfActiveRoute('/tools/folders/') }"
                    >
                        <app-icon [type]="'folder'" class="ms-0" scale="0.8"></app-icon>
                        Folders
                    </app-link>
                </div>
            </div>
        </app-burger-menu>
    </div>
</div>
